import { Image } from "antd";
import { memo } from "react";
import noImgOne from "../../../../images/no-image-one.png";

interface ValidationMediaProps {
  isVideo: boolean;
  src: string;
}

export const ValidationMedia = memo(
  ({ isVideo, src }: ValidationMediaProps) => {

    if (isVideo) {
      return (
        <video
          controls
          style={{ width: "100%", height: "auto", maxHeight: "220px" }}
        >
          <source type="video/mp4" src={src} />
        </video>
      );
    }

    return (
      <Image
        src={src ?? noImgOne}
        style={{ width: "100%", height: "100px" }}
      />
    );
  },
  // Comparación personalizada
  (prevProps, nextProps) => {
    return (
      prevProps.isVideo === nextProps.isVideo && prevProps.src === nextProps.src
    );
  }
);

ValidationMedia.displayName = "ValidationMedia";
